/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <!-- Left: switcher + task checklist -->
      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="selectedSwitch === 'sw1' ? 'primary' : 'grey'" type="filled" class="flex-1" @click="selectedSwitch = 'sw1'">SW-1</vs-button>
          <vs-button
            :color="selectedSwitch === 'sw2' ? 'primary' : 'grey'"
            :disabled="!sw2Unlocked"
            type="filled"
            class="flex-1"
            @click="selectedSwitch = 'sw2'"
          >SW-2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Task 1 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task1Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task1Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task1Done ? '#28C76F' : '#4a5568' }">1</span>
              <span class="font-semibold text-sm flex-1">Configure SW-1 VLAN 35 — SALES</span>
              <span class="text-xs font-medium" :class="task1Done ? 'text-success' : 'text-grey'">{{ task1Items.filter(i => sw1Completion[i.key]).length }}/{{ task1Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task1Items" :key="'t1-' + item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: sw1Completion[item.key] ? '#28C76F' : 'transparent', border: '2px solid ' + (sw1Completion[item.key] ? '#28C76F' : '#6b7280') }"></div>
                <code class="text-base" :class="sw1Completion[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 2 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task2Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task2Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task2Done ? '#28C76F' : '#4a5568' }">2</span>
              <span class="font-semibold text-sm flex-1">Configure SW-2 VLAN 39 — MARKETING</span>
              <span class="text-xs font-medium" :class="task2Done ? 'text-success' : 'text-grey'">{{ task2Items.filter(i => sw2Completion[i.key]).length }}/{{ task2Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task2Items" :key="'t2-' + item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: sw2Completion[item.key] ? '#28C76F' : 'transparent', border: '2px solid ' + (sw2Completion[item.key] ? '#28C76F' : '#6b7280') }"></div>
                <code class="text-base" :class="sw2Completion[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task3Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task3Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task3Done ? '#28C76F' : '#4a5568' }">3</span>
              <span class="font-semibold text-sm flex-1">SW-1 Port — PC1</span>
              <span class="text-xs font-medium" :class="task3Done ? 'text-success' : 'text-grey'">{{ task3Items.filter(i => sw1Completion[i.key]).length }}/{{ task3Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task3Items" :key="'t3-' + item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: sw1Completion[item.key] ? '#28C76F' : 'transparent', border: '2px solid ' + (sw1Completion[item.key] ? '#28C76F' : '#6b7280') }"></div>
                <code class="text-base" :class="sw1Completion[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task4Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task4Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task4Done ? '#28C76F' : '#4a5568' }">4</span>
              <span class="font-semibold text-sm flex-1">SW-2 Port — PC2</span>
              <span class="text-xs font-medium" :class="task4Done ? 'text-success' : 'text-grey'">{{ task4Items.filter(i => sw2Completion[i.key]).length }}/{{ task4Items.length }}</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div v-for="item in task4Items" :key="'t4-' + item.key" class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: sw2Completion[item.key] ? '#28C76F' : 'transparent', border: '2px solid ' + (sw2Completion[item.key] ? '#28C76F' : '#6b7280') }"></div>
                <code class="text-base" :class="sw2Completion[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
              </div>
            </div>
          </div>

          <!-- Task 5 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (task5Done ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: task5Done ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{ width:'20px', height:'20px', fontSize:'10px', background: task5Done ? '#28C76F' : '#4a5568' }">5</span>
              <span class="font-semibold text-sm flex-1">Configure LLDP</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swKey in ['sw1','sw2']" :key="swKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background: rgba(255,255,255,0.07); letter-spacing: 0.05em">{{ swKey === 'sw1' ? 'SW-1' : 'SW-2' }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in (swKey === 'sw1' ? task5Sw1Items : task5Sw2Items)" :key="swKey + '-' + item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: (swKey==='sw1' ? sw1Completion : sw2Completion)[item.key] ? '#28C76F' : 'transparent', border: '2px solid ' + ((swKey==='sw1' ? sw1Completion : sw2Completion)[item.key] ? '#28C76F' : '#6b7280') }"></div>
                    <code class="text-base" :class="(swKey==='sw1' ? sw1Completion : sw2Completion)[item.key] ? 'text-success' : ''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Verification -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{ border: '1px solid ' + (verifyDone ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: verifyDone ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <feather-icon :icon="verifyDone ? 'CheckCircleIcon' : 'CircleIcon'" :svgClasses="verifyDone ? 'text-success' : 'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Verification — SW-1</span>
            </div>
            <div class="px-3 py-2 space-y-1">
              <div class="flex items-center gap-2">
                <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: sw1Completion.verifyShowLldp ? '#28C76F' : 'transparent', border: '2px solid ' + (sw1Completion.verifyShowLldp ? '#28C76F' : '#6b7280') }"></div>
                <code class="text-base" :class="sw1Completion.verifyShowLldp ? 'text-success' : ''">show lldp neighbors</code>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{ border: '1px solid ' + (saveDone ? '#28C76F' : '#3a3f51') }">
            <div class="flex items-center gap-2 px-3 py-2" :style="{ background: saveDone ? 'rgba(40,199,111,0.08)' : 'rgba(255,255,255,0.03)' }">
              <feather-icon :icon="saveDone ? 'CheckCircleIcon' : 'CircleIcon'" :svgClasses="saveDone ? 'text-success' : 'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone ? 'text-success' : 'text-grey'">{{ [sw1Completion.saved, sw2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swKey in ['sw1','sw2']" :key="swKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background: rgba(255,255,255,0.07); letter-spacing: 0.05em">{{ swKey === 'sw1' ? 'SW-1' : 'SW-2' }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: (swKey==='sw1' ? sw1 : sw2).endDone ? '#28C76F' : 'transparent', border: '2px solid ' + ((swKey==='sw1' ? sw1 : sw2).endDone ? '#28C76F' : '#6b7280') }"></div>
                    <code class="text-base" :class="(swKey==='sw1' ? sw1 : sw2).endDone ? 'text-success' : ''">end</code>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{ width:'8px', height:'8px', background: (swKey==='sw1' ? sw1Completion : sw2Completion).saved ? '#28C76F' : 'transparent', border: '2px solid ' + ((swKey==='sw1' ? sw1Completion : sw2Completion).saved ? '#28C76F' : '#6b7280') }"></div>
                    <code class="text-base" :class="(swKey==='sw1' ? sw1Completion : sw2Completion).saved ? 'text-success' : ''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <!-- Right: Terminals -->
      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command
            v-show="selectedSwitch === 'sw1'"
            key="sw1"
            id="sw1_terminal"
            :commands="sw1Commands"
            :prompt="sw1Prompt"
            :show-intro="true"
            intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands."
            style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem; height: 100%"
            title="SW-1"
          />
          <vue-command
            v-show="selectedSwitch === 'sw2'"
            key="sw2"
            id="sw2_terminal"
            :commands="sw2Commands"
            :prompt="sw2Prompt"
            :show-intro="true"
            intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands."
            style="background-color: #111111; border: 1px solid #181d2a; border-radius: 0.5rem; height: 100%"
            title="SW-2"
          />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP_TEXT =
  'Commands:<br>' +
  '&nbsp;vlan [id]<br>' +
  '&nbsp;name [vlan-name]<br>' +
  '&nbsp;interface [e0/x] | int [e0/x]<br>' +
  '&nbsp;switchport mode access<br>' +
  '&nbsp;switchport access vlan [id]<br>' +
  '&nbsp;no shutdown | no shut<br>' +
  '&nbsp;lldp run<br>' +
  '&nbsp;no lldp receive | no lldp transmit<br>' +
  '&nbsp;show lldp neighbors<br>' +
  '&nbsp;copy running-config startup-config<br>' +
  '&nbsp;exit | end<br>';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      selectedSwitch: 'sw1',
      totalScore: 0,

      task1Items: [
        { key: 'vlanCreated', cmd: 'vlan 35' },
        { key: 'vlanNamed',   cmd: 'name SALES' },
        { key: 'vlanExited',  cmd: 'exit' },
      ],
      task2Items: [
        { key: 'vlanCreated', cmd: 'vlan 39' },
        { key: 'vlanNamed',   cmd: 'name MARKETING' },
        { key: 'vlanExited',  cmd: 'exit' },
      ],
      task3Items: [
        { key: 'intE02',        cmd: 'int e0/2' },
        { key: 'e02AccessMode', cmd: 'switchport mode access' },
        { key: 'e02Vlan',       cmd: 'switchport access vlan 35' },
        { key: 'e02NoShut',     cmd: 'no shut' },
        { key: 'e02Exited',     cmd: 'exit' },
      ],
      task4Items: [
        { key: 'intE02',        cmd: 'int e0/2' },
        { key: 'e02AccessMode', cmd: 'switchport mode access' },
        { key: 'e02Vlan',       cmd: 'switchport access vlan 39' },
        { key: 'e02NoShut',     cmd: 'no shut' },
        { key: 'e02Exited',     cmd: 'exit' },
      ],
      task5Sw1Items: [
        { key: 'lldpGlobal',   cmd: 'lldp run' },
        { key: 'intE02Lldp',   cmd: 'int e0/2' },
        { key: 'e02NoLldpRx',  cmd: 'no lldp receive' },
        { key: 'e02NoLldpTx',  cmd: 'no lldp transmit' },
      ],
      task5Sw2Items: [
        { key: 'lldpGlobal', cmd: 'lldp run' },
      ],

      sw1: {
        mode: 'exec',
        currentVlan: null,
        currentInterface: null,
        vlans: {},
        interfaces: {},
        lldpGlobal: false,
        endDone: false,
      },
      sw2: {
        mode: 'exec',
        currentVlan: null,
        currentInterface: null,
        vlans: {},
        interfaces: {},
        lldpGlobal: false,
        endDone: false,
      },

      sw1Completion: {
        vlanCreated: false,
        vlanNamed: false,
        vlanExited: false,
        intE02: false,
        e02AccessMode: false,
        e02Vlan: false,
        e02NoShut: false,
        e02Exited: false,
        lldpGlobal: false,
        intE02Lldp: false,
        e02NoLldpRx: false,
        e02NoLldpTx: false,
        verifyShowLldp: false,
        saved: false,
      },

      sw2Completion: {
        vlanCreated: false,
        vlanNamed: false,
        vlanExited: false,
        intE02: false,
        e02AccessMode: false,
        e02Vlan: false,
        e02NoShut: false,
        e02Exited: false,
        lldpGlobal: false,
        saved: false,
      },

      sw1Commands: {
        help:      () => createStdout(HELP_TEXT),
        enable:    () => createStdout(''),
        configure: (x) => this.iosConfigure(this.sw1, x),
        conf:      (x) => this.iosConfigure(this.sw1, x),
        exit:      () => this.iosExit(this.sw1, this.sw1Completion),
        end:       () => this.iosEnd(this.sw1, this.sw1Completion),
        vlan:      (x) => this.iosVlan(this.sw1, this.sw1Completion, { vlanId: 35, vlanName: 'SALES' }, x),
        name:      (x) => this.iosName(this.sw1, this.sw1Completion, { vlanId: 35, vlanName: 'SALES' }, x),
        interface: (x) => this.iosInt(this.sw1, this.sw1Completion, x),
        int:       (x) => this.iosInt(this.sw1, this.sw1Completion, x),
        switchport:(x) => this.iosSwitchport(this.sw1, this.sw1Completion, 35, x),
        no:        (x) => this.iosNo(this.sw1, this.sw1Completion, x),
        lldp:      (x) => this.iosLldp(this.sw1, this.sw1Completion, x),
        show:      (x) => this.iosShow(this.sw1, this.sw1Completion, x),
        copy:      (x) => this.iosCopy(this.sw1, this.sw1Completion, x),
      },

      sw2Commands: {
        help:      () => createStdout(HELP_TEXT),
        enable:    () => createStdout(''),
        configure: (x) => this.iosConfigure(this.sw2, x),
        conf:      (x) => this.iosConfigure(this.sw2, x),
        exit:      () => this.iosExit(this.sw2, this.sw2Completion),
        end:       () => this.iosEnd(this.sw2, this.sw2Completion),
        vlan:      (x) => this.iosVlan(this.sw2, this.sw2Completion, { vlanId: 39, vlanName: 'MARKETING' }, x),
        name:      (x) => this.iosName(this.sw2, this.sw2Completion, { vlanId: 39, vlanName: 'MARKETING' }, x),
        interface: (x) => this.iosInt(this.sw2, this.sw2Completion, x),
        int:       (x) => this.iosInt(this.sw2, this.sw2Completion, x),
        switchport:(x) => this.iosSwitchport(this.sw2, this.sw2Completion, 39, x),
        no:        (x) => this.iosNo(this.sw2, this.sw2Completion, x),
        lldp:      (x) => this.iosLldp(this.sw2, this.sw2Completion, x),
        show:      (x) => this.iosShow(this.sw2, this.sw2Completion, x),
        copy:      (x) => this.iosCopy(this.sw2, this.sw2Completion, x),
      },
    };
  },

  computed: {
    sw1Prompt() {
      switch (this.sw1.mode) {
        case 'exec':        return 'SW-1#';
        case 'config-vlan': return 'SW-1(config-vlan)#';
        case 'config-if':   return 'SW-1(config-if)#';
        default:            return 'SW-1(config)#';
      }
    },
    sw2Prompt() {
      switch (this.sw2.mode) {
        case 'exec':        return 'SW-2#';
        case 'config-vlan': return 'SW-2(config-vlan)#';
        case 'config-if':   return 'SW-2(config-if)#';
        default:            return 'SW-2(config)#';
      }
    },
    sw2Unlocked() { return this.task1Done; },
    task1Done() { const c = this.sw1Completion; return c.vlanCreated && c.vlanNamed && c.vlanExited; },
    task2Done() { const c = this.sw2Completion; return c.vlanCreated && c.vlanNamed && c.vlanExited; },
    task3Done() { const c = this.sw1Completion; return c.intE02 && c.e02AccessMode && c.e02Vlan && c.e02NoShut && c.e02Exited; },
    task4Done() { const c = this.sw2Completion; return c.intE02 && c.e02AccessMode && c.e02Vlan && c.e02NoShut && c.e02Exited; },
    task5Done() { return this.sw1Completion.lldpGlobal && this.sw2Completion.lldpGlobal && this.sw1Completion.e02NoLldpRx && this.sw1Completion.e02NoLldpTx; },
    verifyDone() { return this.sw1Completion.verifyShowLldp; },
    saveDone()   { return this.sw1Completion.saved && this.sw2Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },

  methods: {
    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    iosConfigure(state, x) {
      if (state.mode !== 'exec') return createStderr('% Invalid input detected');
      if (x._[1] === 'terminal' || x._[1] === 't') {
        state.mode = 'config';
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(state, completion) {
      if (state.mode === 'config-vlan') {
        if (completion.vlanNamed && !completion.vlanExited) { completion.vlanExited = true; this.updateScore(); }
        state.mode = 'config';
      } else if (state.mode === 'config-if') {
        if (state.currentInterface === 'e0/2' && completion.e02NoShut && !completion.e02Exited) {
          completion.e02Exited = true;
          this.updateScore();
        }
        state.mode = 'config';
      } else if (state.mode === 'config') {
        state.mode = 'exec';
        state.endDone = true;
      }
      return createStdout('');
    },

    iosEnd(state, completion) {
      const wasConfig = state.mode !== 'exec';
      if (state.mode === 'config-vlan' && completion.vlanNamed && !completion.vlanExited) {
        completion.vlanExited = true;
        this.updateScore();
      }
      if (state.mode === 'config-if' && state.currentInterface === 'e0/2' && completion.e02NoShut && !completion.e02Exited) {
        completion.e02Exited = true;
        this.updateScore();
      }
      state.mode = 'exec';
      if (wasConfig) state.endDone = true;
      return createStdout('');
    },

    iosVlan(state, completion, cfg, x) {
      if (state.mode !== 'config') return createStderr('% Invalid input detected — must be in config mode');
      const vlanId = parseInt(x._[1]);
      if (isNaN(vlanId) || vlanId < 1 || vlanId > 4094) return createStderr('% Invalid VLAN ID');
      state.mode = 'config-vlan';
      state.currentVlan = vlanId;
      if (!state.vlans[vlanId]) state.vlans[vlanId] = {};
      if (vlanId === cfg.vlanId && !completion.vlanCreated) { completion.vlanCreated = true; this.updateScore(); }
      return createStdout(this.guide(`Entered VLAN ${vlanId} configuration mode. VLANs segment a switch into isolated broadcast domains — devices in different VLANs cannot communicate without a Layer 3 device.`));
    },

    iosName(state, completion, cfg, x) {
      if (state.mode !== 'config-vlan') return createStderr('% Invalid input detected');
      const vlanName = x._[1];
      if (!vlanName) return createStderr('% Incomplete command');
      if (!state.vlans[state.currentVlan]) state.vlans[state.currentVlan] = {};
      state.vlans[state.currentVlan].name = vlanName;
      if (state.currentVlan === cfg.vlanId && vlanName === cfg.vlanName && !completion.vlanNamed) {
        completion.vlanNamed = true;
        this.updateScore();
      }
      return createStdout(this.guide(`VLAN ${state.currentVlan} named "${vlanName}". Naming VLANs makes them identifiable in show commands and documentation — much clearer than referring to VLAN IDs alone.`));
    },

    iosInt(state, completion, x) {
      if (state.mode !== 'config') return createStderr('% Invalid input detected');
      let _ifRaw = String(x._[1] || '');
      if (x._[2] && /^\d+\/\d+/.test(String(x._[2]))) _ifRaw = _ifRaw + x._[2];
      const iface = this.normalizeInterface(_ifRaw);
      if (!iface) return createStderr('% Invalid interface');
      state.mode = 'config-if';
      state.currentInterface = iface;
      if (iface === 'e0/2' && !completion.intE02) { completion.intE02 = true; this.updateScore(); }
      // Re-entry of e0/2 for the Task 5 LLDP-disable step — only counts once we are
      // genuinely in Task 5: LLDP enabled globally (lldp run) AND the port task (Task 3)
      // already finished. Gating on lldpGlobal + e02Exited (not just "after no shut")
      // stops a Task 3 typo re-entry from prematurely completing this Task 5 item.
      if (iface === 'e0/2' && state.lldpGlobal && completion.e02Exited && 'intE02Lldp' in completion && !completion.intE02Lldp) {
        completion.intE02Lldp = true;
        this.updateScore();
      }
      return createStdout(this.guide(`Entered interface ${iface} configuration mode. Interface-level commands applied here affect only this port.`));
    },

    iosSwitchport(state, completion, targetVlan, x) {
      if (state.mode !== 'config-if') return createStderr('% Invalid input detected');
      const iface = state.currentInterface;
      if (!state.interfaces[iface]) state.interfaces[iface] = {};
      if (x._[1] === 'mode' && x._[2] === 'access') {
        state.interfaces[iface].mode = 'access';
        if (iface === 'e0/2' && !completion.e02AccessMode) { completion.e02AccessMode = true; this.updateScore(); }
        return createStdout(this.guide('Port set to access mode. Access ports carry traffic for a single VLAN and are typically connected to end devices like PCs and IP phones.'));
      }
      if (x._[1] === 'access' && x._[2] === 'vlan') {
        const vId = parseInt(x._[3]);
        state.interfaces[iface].accessVlan = vId;
        if (iface === 'e0/2' && vId === targetVlan && !completion.e02Vlan) { completion.e02Vlan = true; this.updateScore(); }
        return createStdout(this.guide(`Port assigned to VLAN ${vId}. Traffic entering this port will be tagged with VLAN ${vId} internally, keeping it isolated from other VLANs.`));
      }
      return createStderr('% Invalid input detected');
    },

    iosNo(state, completion, x) {
      if (state.mode !== 'config-if') return createStderr('% Invalid input detected');
      const iface = state.currentInterface;
      if (!state.interfaces[iface]) state.interfaces[iface] = {};
      const sub = x._[1];
      const sub2 = x._[2];

      if (sub === 'shutdown' || sub === 'shut') {
        state.interfaces[iface].shutdown = false;
        if (iface === 'e0/2' && !completion.e02NoShut) { completion.e02NoShut = true; this.updateScore(); }
        return createStdout(
          `%LINK-5-CHANGED: Interface Ethernet${iface.substring(1)}, changed state to up<br>` +
          `%LINEPROTO-5-UPDOWN: Line protocol on Interface Ethernet${iface.substring(1)}, changed state to up` +
          this.guide('Interface brought up. Cisco switch ports default to shutdown on some platforms — "no shutdown" activates the port so it can pass traffic.'),
        );
      }
      if (sub === 'lldp' && sub2 === 'receive') {
        // Task 5 item — only count once LLDP is enabled globally (lldp run). Without this
        // gate, typing it during the Task 3 port config marks a later step prematurely.
        if (iface === 'e0/2' && state.lldpGlobal && 'e02NoLldpRx' in completion && !completion.e02NoLldpRx) {
          completion.e02NoLldpRx = true;
          this.updateScore();
        }
        return createStdout(this.guide('LLDP receive disabled on this port. The switch will no longer process incoming LLDP frames on e0/2 — useful on access ports facing untrusted end devices.'));
      }
      if (sub === 'lldp' && sub2 === 'transmit') {
        // Task 5 item — gated on lldpGlobal for the same reason as 'no lldp receive'.
        if (iface === 'e0/2' && state.lldpGlobal && 'e02NoLldpTx' in completion && !completion.e02NoLldpTx) {
          completion.e02NoLldpTx = true;
          this.updateScore();
        }
        return createStdout(this.guide('LLDP transmit disabled on this port. The switch will not advertise itself via LLDP on e0/2, preventing end devices from learning topology information.'));
      }
      return createStderr('% Invalid input detected');
    },

    iosLldp(state, completion, x) {
      if (state.mode === 'config' && x._[1] === 'run') {
        state.lldpGlobal = true;
        if (!completion.lldpGlobal) { completion.lldpGlobal = true; this.updateScore(); }
        return createStdout(this.guide('LLDP enabled globally. LLDP (Link Layer Discovery Protocol) is a vendor-neutral IEEE 802.1AB standard — unlike CDP, it works with non-Cisco neighbors.'));
      }
      return createStderr('% Invalid input detected');
    },

    iosShow(state, completion, x) {
      if (state.mode !== 'exec') return createStderr('% Use "end" or "exit" to return to privileged EXEC mode first');
      if (x._[1] === 'lldp' && x._[2] === 'neighbors') {
        if (!state.lldpGlobal) return createStdout('% LLDP is not enabled');
        const out =
          'Capability codes:<br>' +
          '&nbsp;&nbsp;(R) Router, (B) Bridge, (T) Telephone, (C) DOCSIS Cable Device<br>' +
          '&nbsp;&nbsp;(W) Wireless LAN AP, (P) Repeater, (S) Station, (O) Other<br><br>' +
          'Device ID&nbsp;&nbsp;&nbsp;&nbsp;Local Intf&nbsp;&nbsp;&nbsp;&nbsp;Hold-time&nbsp;&nbsp;&nbsp;&nbsp;Capability&nbsp;&nbsp;&nbsp;&nbsp;Port ID<br>' +
          'SW-2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Et0/1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;120&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;S&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Et0/1<br>' +
          'Total entries displayed: 1<br>';
        if ('verifyShowLldp' in completion && !completion.verifyShowLldp) {
          completion.verifyShowLldp = true;
          this.updateScore();
        }
        return createStdout(out + this.guide('LLDP neighbor table shows SW-2 discovered via Et0/1. Each entry confirms bidirectional LLDP adjacency — both devices must have LLDP enabled and transmit/receive active on the connected port.'));
      }
      return createStderr('% Invalid input detected');
    },

    iosCopy(state, completion, x) {
      if (state.mode !== 'exec') return createStderr('% Invalid input detected');
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!completion.saved) { completion.saved = true; this.updateScore(); }
        return createStdout('Building configuration...<br>[OK]' + this.guide('Configuration saved to NVRAM. Running-config holds active settings in RAM; startup-config persists them across reboots.'));
      }
      return createStderr('% Invalid input detected');
    },

    normalizeInterface(raw) {
      if (!raw) return null;
      const s = raw.toLowerCase();
      if (/^(ethernet|e)0\/[0-9]+$/.test(s)) return `e${s.replace(/^(ethernet|e)/, '')}`;
      if (/^(fastethernet|fa|f)0\/[0-9]+$/.test(s)) return `e${s.replace(/^(fastethernet|fa|f)/, '')}`;
      return null;
    },

    updateScore() {
      let score = 0;
      Object.values(this.sw1Completion).forEach((v) => { if (v) score++; });
      Object.values(this.sw2Completion).forEach((v) => { if (v) score++; });
      this.totalScore = score;
      this.$emit('simulation_update_score', score);
      if (score >= 24) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },
  },

  components: { VueCommand },

  props: {
    data: { type: Object, required: true },
  },
};
</script>

<style>
#sw1_terminal,
#sw2_terminal {
  overflow: hidden !important;
}
</style>

